import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileSaveService {

  constructor(private readonly http: HttpClient) {
  }

  saveFile(blob: Blob, suggestedName = 'UnknownFile') {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = suggestedName;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }

  saveFileFromUrlBlob(objectUrl: string, suggestedName = 'UnknownFile') {
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = suggestedName;
    a.click();
  }

  /** `channel_id` of the chat: for an OLX channel the backend requests the file with its OLX token */
  downloadMediaFromUrl(url: string, channel_id?: string) {
    return this.http.post(environment.baseURL + '/download-by-url', { url, channel_id }, { responseType: 'blob' } );
  }
}
